import React, { useState } from 'react';
import { ArrowDropDown as ArrowDropDownIcon, Check as CheckIcon } from '@mui/icons-material';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useLeagueSelectorItems } from './useLeagueSelectorItems';

function LeagueSelector() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);
  const { leagues, currentLeague, leagueId, navigateToLeague } = useLeagueSelectorItems();
  const label = currentLeague?.name ?? 'Select league';

  return (
    <>
      <Button
        sx={{ color: 'common.white', textTransform: 'inherit', minWidth: 0 }}
        endIcon={<ArrowDropDownIcon />}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {leagues.length === 0 && <MenuItem disabled>No leagues yet</MenuItem>}
        {leagues.map(league => (
          <MenuItem
            key={league.id}
            selected={league.id === leagueId}
            onClick={() => {
              setAnchorEl(null);
              navigateToLeague(league);
            }}
          >
            {league.id === leagueId && (
              <ListItemIcon>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
            )}
            <ListItemText inset={league.id !== leagueId}>{league.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default LeagueSelector;
